import {createApp} from 'vue'
import {createRouterFromJson} from './router'
import App from "@/App";
import {BootstrapVue3} from 'bootstrap-vue-3'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'

createRouterFromJson()
    .then(r => {
        createApp(App).use(r).use(BootstrapVue3).mount('#app');
    });